import { css } from '@emotion/react';
import { tokens, media, applyFont } from '@domain-group/fe-brary';

export const ultimateGuides = css`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.s};
`;

export const wrapper = css`
  display: flex;
  gap: ${tokens.spacing.s};
  padding: 0;
  margin: 0;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  & > li {
    flex: 0 0 80%;
    scroll-snap-align: start;
    list-style: none;
  }

  ${media('>=tablet')} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: ${tokens.spacing.s};
    grid-row-gap: ${tokens.spacing.s};
    overflow-x: unset;

    & > li {
      flex: unset;
    }

    & > li:nth-child(4) {
      display: none;
    }
  }

  ${media('>=desktop')} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: ${tokens.spacing.m};

    & > li:nth-child(4) {
      display: list-item;
    }
  }
`;

export const titleWrapper = css`
  display: flex;
  justify-content: space-between;
`;

export const title = css`
  ${applyFont(tokens.typography.heading)}
  color: ${tokens.colors.neutral.heavy.default};
  margin-bottom: ${tokens.spacing.m};

  ${media('>=tablet')} {
    margin-right: ${tokens.spacing.s};
  }
`;

export const viewAll = css`
  display: inline-block;
  color: ${tokens.colors.interactive.base.default};
  ${applyFont(tokens.typography.body)}
  text-decoration: none;

  &:hover {
    color: ${tokens.colors.interactive.base.hover};
  }
`;
